$('document').ready(function () {
    $('.zip_code').on('blur', function () {
        var cep_code = $(this).val();
        var name = $(this).attr('name');
        if (cep_code.length <= 0) return;
        $.get("https://apps.widenet.com.br/busca-cep/api/cep.json",
            {code: cep_code},
            function (result) {
                if (result.status != 1) {
                    return;
                }
                $('input[name="' + name.replace('zip_code', 'city') + '"]').val(result.city).trigger('focusout');
                $('input[name="' + name.replace('zip_code', 'neighborhood') + '"]').val(result.district).trigger('focusout');
                $('input[name="' + name.replace('zip_code', 'street') + '"]').val(result.address).trigger('focusout');
                $('input[name="' + name.replace('zip_code', 'state') + '"]').val(result.state).trigger('focusout');
            });
    });
});


// WEBPACK FOOTER //
// ./resources/assets/admin/js/scripts/script-get-address.js